// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3N4pz","question":"Question_question__3EHbM","description":"Question_description__2rBjO"};